// AgendaLoadingSkeleton: Skeleton loader for the agenda list view
// Mimics the structure of day sections and mission rows while data loads
// CREATED: Part of the agenda list view for TeamView

function SkeletonRow({ wide = false }: { wide?: boolean }) {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 border-b border-gray-50">
      <span className="w-2.5 h-2.5 rounded-full bg-gray-200 flex-shrink-0 animate-pulse" />
      <span className={`h-3.5 rounded bg-gray-200 animate-pulse flex-1 ${wide ? 'max-w-[70%]' : 'max-w-[50%]'}`} />
      <span className="h-3 rounded bg-gray-100 animate-pulse w-24 flex-shrink-0" />
      <span className="h-3 rounded bg-gray-100 animate-pulse w-14 flex-shrink-0" />
    </div>
  );
}

function SkeletonDaySection({ rowCount }: { rowCount: number }) {
  return (
    <div>
      <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100">
        <span className="h-3 rounded bg-gray-200 animate-pulse w-36" />
        <span className="h-3 rounded bg-gray-100 animate-pulse w-16" />
      </div>
      {Array.from({ length: rowCount }).map((_, i) => (
        <SkeletonRow key={i} wide={i % 2 === 0} />
      ))}
    </div>
  );
}

export function AgendaLoadingSkeleton() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <SkeletonDaySection rowCount={4} />
      <SkeletonDaySection rowCount={3} />
      <SkeletonDaySection rowCount={5} />
      <SkeletonDaySection rowCount={2} />
    </div>
  );
}
